import {
  // eslint-disable-next-line no-restricted-imports
  DialogContent as MuiDialogContent,
  DialogContentProps as MuiDialogContentProps,
} from '@material-ui/core';
import { Theme } from '@emotion/react';
import { dialogContent } from 'omakase/Dialog/dialogCoreCssDefs';
import React from 'react';

export interface DialogContentBaseProps {
  /**
   * Disable default padding for the dialog content
   */
  disablePadding?: boolean;
}

export type DialogContentProps = DialogContentBaseProps & MuiDialogContentProps;

const DialogContent = React.forwardRef<HTMLDivElement, DialogContentProps>(
  ({ children, disablePadding = false, ...rest }, ref) => {
    return (
      <MuiDialogContent
        css={(theme: Theme) => dialogContent(theme, { disablePadding })}
        ref={ref}
        data-omakase-dialog-content
        {...rest}
      >
        {children}
      </MuiDialogContent>
    );
  }
);

export default DialogContent;
